import * as React from 'react'
import { useMemo } from 'react'

import type { CustomFieldProps } from './typings'
import { AdditionalInfoListItem } from '@sales-center/components'
import type { CustomFieldCheckboxValue } from '@sales-center/common'

type CustomCheckboxProps = CustomFieldProps & {
  value: CustomFieldCheckboxValue
}

export function CustomCheckbox(props: CustomCheckboxProps) {
  const {
    customFields,
    value: { customFieldId, bool },
  } = props

  const thisField = useMemo(
    () => customFields.find((x) => x.id === customFieldId),
    [customFieldId, customFields],
  )

  if (!thisField) return null

  const subtitle = bool === null ? '-' : bool ? 'Yes' : 'No'

  return <AdditionalInfoListItem title={thisField.name} subtitle={subtitle} />
}
